import { render, staticRenderFns } from "./mobile-noteproperty.vue?vue&type=template&id=4d817193&scoped=true&"
import script from "./mobile-noteproperty.vue?vue&type=script&lang=js&"
export * from "./mobile-noteproperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d817193",
  null
  
)

export default component.exports